import {jwtDecode} from 'jwt-decode';

import {
  CTokenDecoded,
  ITokenDecoded,
  ITokenDecodedUser,
  RolesAccount,
} from '@/app/auth';
import {RoleType} from '@/app/store/authSlice';
import {userManager} from '@/app/store/userManager';
import {TRACK_DATA_CONSTANTS} from '@/constants';
import {
  IMoEngageUserEvent,
  IUserEventDataDefinition,
  IUserEventSchema,
  IUserTrack,
} from '@/services';
import logError from '@/utils/errors/logError';

export const getUserSchema = (
  user?: IUserEventDataDefinition,
): IUserEventSchema => {
  let userSchema: IUserEventSchema = {
    user: null,
  };

  const userTrack = getUserTrack();
  userSchema = transformUserTrackToUserUserSchema(userTrack);

  userSchema.user = {...userSchema.user, ...user};
  return userSchema;
};

const transformUserTrackToUserUserSchema = (
  userTrack: IUserTrack,
): IUserEventSchema => {
  return {
    user: {
      id: userTrack?.uuid ?? '',
      email: userTrack?.email ?? TRACK_DATA_CONSTANTS.DEFAULT_EMAIL,
      phone: userTrack?.phone,
      role: userTrack?.type,
    },
  };
};

export const getUserTrack = (): IUserTrack => {
  const token = userManager.getToken();
  let tokenUserId = null;

  if (token && token.accessToken) {
    const tokenDecoded = getTokenDecodedUser(token.accessToken);

    tokenUserId = tokenDecoded.user_uuid;
  }

  return {
    uuid: token?.id ?? (tokenUserId as string),
    email: token?.email,
    phone: token?.phone,
    type: token?.role,
    name: token?.name,
  };
};

export const getTokenDecodedUser = (
  token: string,
  defaultRole?: RoleType,
): ITokenDecodedUser => {
  if (!defaultRole) defaultRole = RolesAccount.PARENT;

  const tokenDecoded = getTokenDecoded(token);

  if (!tokenDecoded) return null;

  const userId = tokenDecoded[CTokenDecoded.CUSTOM_USER_UUID] ?? '';
  const role = tokenDecoded[CTokenDecoded.CUSTOM_ROLES] ?? defaultRole;
  return {
    ...tokenDecoded,
    user_uuid: userId,
    role,
  };
};

export const getTokenDecoded = (token: string): ITokenDecoded | null => {
  if (!token) return null;

  try {
    const tokenDecoded: ITokenDecoded = jwtDecode(token);
    return tokenDecoded || null;
  } catch (error) {
    logError(error, {
      fileName: 'getUserSchema.ts',
      functionName: 'getTokenDecoded',
    });
    return null;
  }
};

export const transformUserToUserForMoEngageUser = (
  user: IUserEventDataDefinition,
): IMoEngageUserEvent => {
  return {
    user_uuid: user?.id ?? '',
    user_type: user?.role ?? '',
    user_phone: user?.phone ?? '',
    user_email: user?.email ?? '',
  };
};
